import bg2 from "../images/backgrounds/bg-2.png";
/* jshint esversion: 6 */
/* jshint ignore:start */
import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MyContext } from "../Context/MyProvider";
import axios from "axios";
import { Formik } from "formik";
import { TodoContext } from "../Context";
import { showTost } from "../showTost";
import { uid } from "uid";
import ProgressBar from "./ProgressBar";

const Imagecom = () => {
  const { demo, setDemo } = useContext(TodoContext);
  const {
    name,
    email,
    password,
    bio,
    number,
    ccode,
    birthdate,
    gender,
    goal,
    nearby,
    hobbies,
    languages,
    religion,
    preference,
    basUrl,
    latitude,
    setLatitude,
    longitude,
    setLongitude,
  } = useContext(MyContext);

  const navigate = useNavigate();

  const [images, setImages] = useState(Array(6).fill(null));
  const [isSubmitting, setIsSubmitting] = useState(false);
  const fileInputRefs = useRef([]);

  const order = [0, 3, 4, 5, 2, 1];

  const toCsv = (value) =>
    Array.isArray(value) ? value.join(",") : String(value || "").trim();

  const normalizeCountryCode = (value) => {
    const clean = String(value || "").trim();
    if (!clean) return "+1";
    return clean.startsWith("+") ? clean : `+${clean}`;
  };

  const isValidCoordinate = (value) => {
    if (value === undefined || value === null) return false;
    const text = String(value).trim();
    if (!text || text === "undefined" || text === "null") return false;
    const number = Number(text);
    return Number.isFinite(number) && number !== 0;
  };

  const getLocationErrorTitle = (error) => {
    if (error?.code === error.PERMISSION_DENIED) {
      return "Location permission denied. Enable it in your browser settings and try again.";
    }
    if (error?.code === error.POSITION_UNAVAILABLE) {
      return "Location unavailable. Turn on device location and try again.";
    }
    if (error?.code === error.TIMEOUT) {
      return "Location request timed out. Please try again.";
    }
    return "Please enable location access to continue.";
  };

  const slotConfigs = [
    {
      index: 0,
      roundedClass: "rounded-tl-[15px]",
      heightClass: "h-[210px] max-_430_:h-[170px] text-[30px]",
    },
    {
      index: 1,
      roundedClass: "rounded-bl-[15px]",
      heightClass: "h-[105px] max-_430_:h-[85px]",
    },
    { index: 2, roundedClass: "", heightClass: "h-[105px] max-_430_:h-[85px]" },
    {
      index: 3,
      roundedClass: "rounded-tr-[15px]",
      heightClass: "h-[105px] max-_430_:h-[85px]",
    },
    { index: 4, roundedClass: "", heightClass: "h-[105px] max-_430_:h-[85px]" },
    {
      index: 5,
      roundedClass: "rounded-br-[15px]",
      heightClass: "h-[105px] max-_430_:h-[85px]",
    },
  ];

  const getIsEnabled = (index) => {
    if (index === 0) return true;
    const k = order.indexOf(index);
    return !!images[order[k - 1]];
  };

  const getBorderClass = (index) => {
    if (images[index]) return "border-gray-300";
    if (getIsEnabled(index)) return "border-[#980eff]";
    return "border-transparent";
  };

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLatitude(String(position.coords.latitude));
          setLongitude(String(position.coords.longitude));
        },
        (error) => {
          console.error("Geolocation error:", error);
          showTost({ title: getLocationErrorTitle(error) });
        },
      );
    } else {
      showTost({ title: "Geolocation is not supported by your browser." });
    }
  }, [setLatitude, setLongitude]);

  const renderSlot = (index, props) => {
    const config = slotConfigs[index];
    const isEnabled = getIsEnabled(index);
    const hasImage = !!images[index];
    const borderClass = getBorderClass(index);

    return (
      <button
        type="button"
        disabled={!isEnabled}
        onClick={() => fileInputRefs.current[index].click()}
        className={`w-full border-[2px] ${borderClass} ${config.roundedClass} ${config.heightClass} overflow-hidden flex items-center justify-center p-0 m-0`}
      >
        <input
          ref={(el) => (fileInputRefs.current[index] = el)}
          type="file"
          accept="image/*"
          className="hidden"
          onChange={(e) => {
            const file = e.target.files[0];
            if (!file) return;
            const newImages = [...images];
            newImages[index] = file;
            setImages(newImages);
            if (index === 0) props.setFieldValue("otherpic0", file);
            if (index === 3) props.setFieldValue("otherpic1", file);
            if (index === 4) props.setFieldValue("otherpic2", file);
          }}
        />
        {hasImage ? (
          <img
            src={URL.createObjectURL(images[index])}
            className="w-full h-full object-cover"
            alt="Uploaded"
          />
        ) : (
          isEnabled && "+"
        )}
      </button>
    );
  };

  return (
    <div>
      <Formik
        initialValues={{
          otherpic0: "",
          otherpic1: "",
          otherpic2: "",
        }}
        onSubmit={async () => {
          const selectedFiles = images.filter(Boolean).slice(0, 3);
          if (selectedFiles.length < 3) {
            showTost({ title: "Please select at least 3 images." });
            return;
          }

          if (!isValidCoordinate(latitude) || !isValidCoordinate(longitude)) {
            showTost({
              title: "Please allow location access before proceeding.",
            });
            return;
          }

          if (!isSubmitting) {
            setIsSubmitting(true);

            const formData = new FormData();
            formData.append("name", String(name || "").trim());
            formData.append("email", String(email || "").trim());
            formData.append("mobile", String(number || "").trim());
            formData.append("ccode", normalizeCountryCode(ccode));
            formData.append("birth_date", String(birthdate || "").trim());
            formData.append("search_preference", String(preference || "").trim());
            formData.append("radius_search", String(nearby || "").trim());
            formData.append("relation_goal", String(goal || "").trim());
            formData.append("profile_bio", String(bio || "").trim());
            formData.append("interest", toCsv(hobbies));
            formData.append("language", toCsv(languages));
            formData.append("password", String(password || "").trim());
            formData.append("gender", String(gender || "").trim());
            formData.append("lats", String(latitude).trim());
            formData.append("longs", String(longitude).trim());
            formData.append("religion", String(religion || "").trim());
            formData.append("refercode", "");
            formData.append("size", String(selectedFiles.length));
            selectedFiles.forEach((file, index) => {
              formData.append(`otherpic${index}`, file);
            });

            axios
              .post(`${basUrl}reg_user`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
              })
              .then((res) => {
                if (res.data.Result === "true") {
                  setDemo(demo + "123");
                  localStorage.setItem(
                    "UserId",
                    res.data?.UserLogin?.id || "00",
                  );
                  const token = res.data.token || uid(32);
                  localStorage.setItem("token", token);
                  localStorage.setItem(
                    "Register_User",
                    JSON.stringify(res.data.UserLogin),
                  );
                  navigate("/");
                  showTost({ title: res.data.ResponseMsg });
                } else {
                  showTost({ title: res.data.ResponseMsg });
                }
              })
              .catch((error) => {
                showTost({
                  title:
                    error?.response?.data?.ResponseMsg ||
                    error?.message ||
                    "Unable to complete registration.",
                });
              })
              .finally(() => {
                setIsSubmitting(false);
              });
          }
        }}
      >
        {(props) => (
          <div className="w-[100%] multisteup-wrapper pt-[20px] Test" style={{ backgroundImage: `url(${bg2})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", backgroundSize: "cover" }}>
            <div className="container mx-auto">
              <section className="steps step-1 active rounded-[24px] relative">
                <ProgressBar step={11} />
                <div className="mt-[10px]">
                  <h1 className="text-[22px] max-_430_:text-[27px] font-[600] max-_430_:w-[260px]">
                    Show your best self 📸
                  </h1>
                  <p className="text-[20px] mt-[10px] max-_430_:text-[16px]">
                    Upload at least 3 photos to make a fantastic first
                    impression. Let your personality shine.
                  </p>
                </div>

                <form
                  onSubmit={props.handleSubmit}
                  className="mt-[20px] w-[80%]"
                >
                  <div>
                    <div className="flex">
                      <div className="w-[65%] relative">
                        {renderSlot(0, props)}
                        <div className="flex">
                          {renderSlot(1, props)}
                          {renderSlot(2, props)}
                        </div>
                      </div>
                      <div className="w-[35%]">
                        {renderSlot(3, props)}
                        {renderSlot(4, props)}
                        {renderSlot(5, props)}
                      </div>
                    </div>
                  </div>

                  <button
                    type="submit"
                    className="btn btn-w-md nextstep mt-[24px]"
                  >
                    <div className="flex items-center justify-center gap-[10px]">
                      <span className="font-bold text-[1.25rem] text-white">
                        Next
                      </span>
                      <svg
                        className="mx-6"
                        width="19"
                        height="13"
                        viewBox="0 0 19 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.75455 5.73075H15.4523L11.3296 1.60802C11.2552 1.53617 11.1959 1.45022 11.155 1.35519C11.1142 1.26016 11.0927 1.15795 11.0918 1.05453C11.0909 0.951108 11.1106 0.848543 11.1498 0.752818C11.189 0.657094 11.2468 0.570128 11.3199 0.496995C11.3931 0.423862 11.48 0.366026 11.5758 0.326862C11.6715 0.287698 11.7741 0.267991 11.8775 0.268889C11.9809 0.269788 12.0831 0.291275 12.1781 0.332096C12.2732 0.372918 12.3591 0.432257 12.431 0.50665L17.8833 5.95896C18.0293 6.10503 18.1113 6.30311 18.1113 6.50965C18.1113 6.71618 18.0293 6.91427 17.8833 7.06033L12.431 12.5126C12.2841 12.6545 12.0873 12.733 11.8831 12.7313C11.6789 12.7295 11.4835 12.6476 11.3391 12.5032C11.1947 12.3587 11.1128 12.1634 11.111 11.9592C11.1092 11.7549 11.1877 11.5582 11.3296 11.4113L15.4523 7.28855H1.75455C1.54797 7.28855 1.34986 7.20649 1.20378 7.06041C1.05771 6.91434 0.975649 6.71623 0.975649 6.50965C0.975649 6.30307 1.05771 6.10495 1.20378 5.95888C1.34986 5.81281 1.54797 5.73075 1.75455 5.73075Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                  </button>
                </form>
              </section>
            </div>
          </div>
        )}
      </Formik>
    </div>
  );
};

export default Imagecom;
/* jshint ignore:end */
